import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";

const OPTIONS_STALE_TIME_MS = 10 * 60 * 1000;

/** DBCO-0059 - the active delay types, the first level of the delay selector. */
export const useDelayTypes = (enabled = true) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.delayTypes(),
    queryFn: () => drybulkCargoOperationsService.delayTypes(),
    enabled,
    retry: false,
    staleTime: OPTIONS_STALE_TIME_MS,
  });

/** DBCO-0059 - the active delay codes of one type, loaded only once a type is chosen. */
export const useDelayCodes = (delayTypeCode: string | undefined) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.delayCodes(delayTypeCode ?? ""),
    queryFn: () => drybulkCargoOperationsService.delayCodes(delayTypeCode as string),
    enabled: Boolean(delayTypeCode),
    retry: false,
    staleTime: OPTIONS_STALE_TIME_MS,
  });
